import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { CircularProgress, Box } from '@mui/material';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, tokenValid, permissionsReady, checkTokenValidity } = useAuth();
  const [isVerifying, setIsVerifying] = useState(false);

  useEffect(() => {
    // If user is authenticated but token hasn't been verified yet, verify it
    if (isAuthenticated && !tokenValid && !loading) {
      setIsVerifying(true);
      checkTokenValidity().finally(() => {
        setIsVerifying(false);
      });
    }
  }, [isAuthenticated, tokenValid, loading, checkTokenValidity]);

  // Show loading during initial authentication check
  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  // If not authenticated, redirect to login immediately
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If authenticated but token verification is in progress, show loading
  if (isVerifying) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  // If token is invalid, redirect to login
  if (!tokenValid) {
    return <Navigate to="/login" replace />;
  }

  // Wait for permissions to be loaded before rendering children
  if (!permissionsReady) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return children;
};

export default ProtectedRoute;